module.exports = __webpack_public_path__ + "static/media/welcome-prayer-music.ed5e9a3f.mp3";